/** Hour 0–23 in CST when account has no second message time (null/undefined). */
export const DEFAULT_SECOND_MESSAGE_HOUR_CST = 19; // 7 PM

/** Hour 0–23 in CST when account has no third message time (null/undefined). */
export const DEFAULT_THIRD_MESSAGE_HOUR_CST = 7; // 7 AM

// --- DOS > Order Date (future DOS) ---
export const DEFAULT_FUTURE_DOS_SECOND_MESSAGE_DAYS = 3;
export const DEFAULT_FUTURE_DOS_THIRD_MESSAGE_DAYS = 0;

// --- Orders from import tables (DOS < Order Date) ---
export const DEFAULT_INTEGRATION_SECOND_MESSAGE_DAYS = 15;
export const DEFAULT_INTEGRATION_THIRD_MESSAGE_DAYS = 30;

// --- DOS < Order Date (past DOS) ---
export const DEFAULT_PAST_DOS_SECOND_MESSAGE_DAYS = 5;
export const DEFAULT_PAST_DOS_THIRD_MESSAGE_DAYS = 10;
